import { queryClient }  from "services/QueryClient"

export default function useQueryClient() {
    return queryClient
}